import Cookies from 'js-cookie';
export const getCookie = (domain: string) => {
    const map = Cookies.get('X-TOKEN') ? JSON.parse(Cookies.get('X-TOKEN') as string) : {};

    return map[domain || window.location.host];
};

export const addCookie = (prop: string, propVal: string, domain?: string, expires?: number, path?: string) => {
    Cookies.set(prop, propVal, {
        expires: expires || 10,
        path: path || '/',
        domain: domain || '.grtcloud.net'
    });
};
export const getCookieByName = (name: string) => {
    return Cookies.get(name);
};
export const removeCookieByName = (name: string) => {
    Cookies.remove(name);
};
export const updateCookie = (loginInfo: any) => {
    const map = Cookies.get('X-TOKEN') ? JSON.parse(Cookies.get('X-TOKEN') as string) : {};

    map[loginInfo.domain] = {
        access_key: loginInfo.access_key,
        secret_key: loginInfo.secret_key,
        timestamp: loginInfo.timestamp
    };

    Cookies.set('X-TOKEN', JSON.stringify(map), {
        expires: 10,
        path: '/',
        domain: '.grtcloud.net'
    });
};

export const clearCookie = (domain: string) => {
    const map = Cookies.get('X-TOKEN') ? JSON.parse(Cookies.get('X-TOKEN') as string) : {};

    map[domain] = null;

    Cookies.set('X-TOKEN', JSON.stringify(map), {
        expires: 10,
        path: '/',
        domain: '.grtcloud.net'
    });
};
